import {formatter, request} from '@/utils/request';

export namespace ActivityType {

  export const Path = {
    Get: '/mdmapi/activityType/get',
    Post: '/mdmapi/activityType/post',
    Query: '/mdmapi/activityType/query',
    Search: '/mdmapi/activityType/search',
  }


  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.ActivityType>>(Path.Get, formatter(options));
  }

  export async function post(body: API.ActivityTypeFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(Path.Post, formatter(options));
  }

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.Query, formatter(options),);
  }

  export async function search(body: API.ActivityTypeFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.ActivityType[]>>(Path.Search, formatter(options));
  }
}
